import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import type { GlobalSearchQuery, GlobalSearchType } from './type.ts'
import { useLoadGlobalSearch } from './api.ts'
import { useTranslate } from '@/shared/lib'

export const useGlobalSearch = defineStore('global_search', () => {
  const open = ref(false)

  const { trs } = useTranslate()

  const result = ref<GlobalSearchType[]>([])
  const total = ref(0)
  const query = ref<GlobalSearchQuery>({
    q: '',
    limit: 20,
    page: 1,
    offset: 0,
    sort_by: null,
    sort_order: null,
    object_type_id: 0,
    date: '',
    filter: [],
    area: null,
  })

  const objectTypeFields = ref([])

  const { isFetching, data } = useLoadGlobalSearch(query)

  /**
   * Сбрасывает выдачу, когда поисковая строка слишком короткая для запроса.
   */
  const clearResult = () => {
    result.value = []
    total.value = 0
  }

  watch(data, (val) => {
    if (val) {
      result.value = val.data || []
      total.value = val.payload.total || 0
    }
  })

  watch(
    () => query.value.q,
    (val) => {
      if (val.trim().length < 2) clearResult()
    },
  )

  /* Порядок сортировки */
  const sortList = [
    { value: null, title: trs('itf.sort_direction.null') },
    { value: 'desc', title: trs('itf.sort_direction.desc') },
    { value: 'asc', title: trs('itf.sort_direction.asc') },
  ]

  return {
    open,
    result,
    query,
    objectTypeFields,
    total,
    isFetching,
    clearResult,
    sortList,
  }
})
